(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-search"] && !Shopify.designMode) return;
  try {
    (function () {
    function initSearchIdle(root) {
      var input = root.querySelector('.search-modal .field__input');
      var idle = root.querySelector('[data-search-idle]');
      var detailsEl = root.querySelector('details');
      var modalEl = root.querySelector('.search-modal');
      if (!input || !idle || !detailsEl || !modalEl) return;

      function update() {
        idle.hidden = input.value.trim().length > 0;
      }

      function lockScroll() {
        document.body.style.overflow = 'hidden';
      }

      function unlockScroll() {
        document.body.style.overflow = '';
      }

      function updateHeaderOffset() {
        var headerEl = document.querySelector('.shopify-section-header-sticky')
          || document.querySelector('sticky-header')
          || document.querySelector('.header');
        if (!headerEl) return;
        var rect = headerEl.getBoundingClientRect();
        var offset = Math.max(Math.round(rect.bottom), 0);
        modalEl.style.setProperty('--waenn-search-offset', offset + 'px');
      }

      input.addEventListener('input', update);
      window.addEventListener('resize', function () {
        if (detailsEl.hasAttribute('open')) updateHeaderOffset();
      });
      detailsEl.addEventListener('toggle', function () {
        if (detailsEl.hasAttribute('open')) {
          updateHeaderOffset();
          update();
          lockScroll();
        } else {
          unlockScroll();
        }
      });

      var closeButton = root.querySelector('.search-modal__close-button');
      if (closeButton) {
        closeButton.addEventListener('click', function () {
          detailsEl.removeAttribute('open');
          unlockScroll();
        });
      }

      update();
    }

    // WAENN — Si la palabra escrita coincide con una categoria conocida,
    // redirige directamente a esa coleccion (pagina limpia, sin la ventana
    // generica de "Resultados de busqueda" con su barra de filtros), en
    // vez de enviar el formulario a /search.
    var WAENN_SEARCH_CATEGORY_MAP = [
      { words: ['camisa', 'camisas'], handle: 'ropa-camisas' },
      { words: ['abrigo', 'abrigos'], handle: 'abrigos-ver-todo' },
      { words: ['vestido', 'vestidos'], handle: 'ropa-vestidos' },
      { words: ['chandal', 'chandals', 'chandales'], handle: 'ropa-chandal' },
      { words: ['pantalon', 'pantalones'], handle: 'ropa-pantalones' },
      { words: ['falda', 'faldas'], handle: 'ropa-faldas' },
      { words: ['conjunto', 'conjuntos'], handle: 'ropa-conjuntos' },
      { words: ['top', 'tops'], handle: 'ropa-tops' },
      { words: ['ropa'], handle: 'ropa-ver-todo' },
      { words: ['bolso', 'bolsos', 'bolsa', 'bolsas'], handle: 'bolsos-ver-todo' },
      { words: ['anillo', 'anillos'], handle: 'joyeria-anillos' },
      { words: ['joya', 'joyas', 'joyeria'], handle: 'joyeria-ver-todo' }
    ];

    function waennNormalize(value) {
      return (value || '')
        .toString()
        .trim()
        .toLowerCase()
        .normalize('NFD')
        .replace(/[̀-ͯ]/g, '');
    }

    function waennMatchCategoryHandle(query) {
      var normalized = waennNormalize(query);
      if (!normalized) return null;
      for (var i = 0; i < WAENN_SEARCH_CATEGORY_MAP.length; i++) {
        var entry = WAENN_SEARCH_CATEGORY_MAP[i];
        if (entry.words.indexOf(normalized) !== -1) {
          return entry.handle;
        }
      }
      return null;
    }

    function initSearchCategoryRedirect(root) {
      var form = root.querySelector('[data-waenn-search-form]');
      var input = root.querySelector('.search-modal .field__input');
      if (!form || !input) return;

      form.addEventListener('submit', function (event) {
        var handle = waennMatchCategoryHandle(input.value);
        if (handle) {
          event.preventDefault();
          window.location.href = window.Shopify.routes.root + 'collections/' + handle;
        }
      });
    }

    function init() {
      document.querySelectorAll('.header__search').forEach(function (root) {
        initSearchIdle(root);
        initSearchCategoryRedirect(root);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
